import * as React from "react";
const SvgWarning20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 19,
        fill: "black",
        viewBox: "0 0 20 19"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M12.598 2c-1.155-2-4.041-2-5.196 0L.474 14c-1.155 2 .288 4.5 2.598 4.5h13.856c2.31 0 3.753-2.5 2.598-4.5L12.598 2ZM9.134 3a1 1 0 0 1 1.732 0l6.928 12a1 1 0 0 1-.866 1.5H3.072a1 1 0 0 1-.866-1.5L9.134 3ZM11 5v5.5H9V5h2Zm.25 8.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z",
      clipRule: "evenodd"
    })
  );
export default SvgWarning20Px;
